import {
  type CreateDiscountRequest,
  type DiscountDetail,
  DiscountDetailSchema,
  type DiscountListQuery,
  type DiscountListResponse,
  DiscountListResponseSchema,
  type UpdateDiscountRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listDiscounts = async (query: DiscountListQuery): Promise<DiscountListResponse> => {
  const { data } = await apiClient.get<unknown>('/discounts', { params: query });
  return DiscountListResponseSchema.parse(data);
};

export const getDiscount = async (id: string): Promise<DiscountDetail> => {
  const { data } = await apiClient.get<unknown>(`/discounts/${id}`);
  return DiscountDetailSchema.parse(data);
};

export const createDiscount = async (payload: CreateDiscountRequest): Promise<DiscountDetail> => {
  const { data } = await apiClient.post<unknown>('/discounts', payload);
  return DiscountDetailSchema.parse(data);
};

export const updateDiscount = async (
  id: string,
  payload: UpdateDiscountRequest,
): Promise<DiscountDetail> => {
  const { data } = await apiClient.patch<unknown>(`/discounts/${id}`, payload);
  return DiscountDetailSchema.parse(data);
};

export const deleteDiscount = async (id: string): Promise<void> => {
  await apiClient.delete(`/discounts/${id}`);
};
